import { Button } from "../ui/button";

// BUDGET dock state (scenario 677, plan 188 task 802): the per-turn
// mutation-budget notice (D6, max 10 Tier-M writes/turn) plus a "Continue"
// action that sends the literal "continue" the model is listening for.
export function BudgetNotice({
  writesThisTurn,
  onContinue,
}: {
  writesThisTurn: number;
  onContinue: () => void;
}) {
  return (
    <div
      data-testid="copilot-budget-notice"
      className="space-y-2 rounded-md border border-border-soft bg-muted/40 px-3 py-2.5"
    >
      <p className="text-sm text-fg">
        I&apos;ve made {writesThisTurn} updates this turn — say
        &nbsp;&ldquo;continue&rdquo;&nbsp;if you&apos;d like me to keep going.
      </p>
      <Button size="sm" onClick={onContinue}>
        Continue
      </Button>
    </div>
  );
}
